import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { ToastProvider } from '@nolens/ui';
import { router } from './app/router';
import { ApiError } from './lib/api';
import { isConfigured } from './lib/config';
import { SessionProvider } from './lib/session';
import { ConfigMissing } from './routes/RouteError';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Não repetir erros de permissão/inexistência; só falhas transitórias.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isConfigured ? (
      <SessionProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </QueryClientProvider>
      </SessionProvider>
    ) : (
      <ConfigMissing />
    )}
  </StrictMode>,
);
